import Types from '../types';

export default () => ({
  type: Types.CLEAR_ITEM,
});
